export enum ResponseStatus {
    OK = 200,
    DELETED = 204,
    CREATED = 201,
    INVALID_REQUEST = 400,
    INVALID_CREDENTIALS = 401,
    UNPROCESSABLE_ENTITY = 422,
    INTERNAL_SERVER_ERROR = 500,
}
